export enum MassUploadStatus {
  Created = 1,
  InProgress = 2,
  Closed = 3,
  ClosedWithFailures = 4
}

export type MassUploadStatusKey = '1' | '2' | '3' | '4';

export const mapMassUploadStatusToNumber = (
  status: string
): MassUploadStatus => {
  switch (status) {
    case 'Created':
      return MassUploadStatus.Created;
    case 'InProgress':
      return MassUploadStatus.InProgress;
    case 'Closed':
      return MassUploadStatus.Closed;
    case 'ClosedWithFailures':
      return MassUploadStatus.ClosedWithFailures;
    default:
      return MassUploadStatus.InProgress;
  }
};

export const mapMassUploadStatusToKey = (
  status: MassUploadStatus
): MassUploadStatusKey => {
  return status.toString() as MassUploadStatusKey;
};

export interface IMassUploadHistoryItem {
  uploadId?: number;
  requestCreated: string;
  requestStatusUpdate: string;
  totalCount: number;
  created: number | null;
  updated: number | null;
  unchanged: number;
  failed: number;
  status: string;
}

export interface IMassUploadHistoryItemWithNumericStatus
  extends Omit<IMassUploadHistoryItem, 'status'> {
  status: MassUploadStatus;
}

export interface IMassUploadHistoryResponse {
  currentPage: number;
  totalPages: number;
  rowsPerPage: number;
  totalCount: number;
  items: IMassUploadHistoryItem[];
}
export type ValidateUserDataPayload = {
  id: string;
  personal_id: string;
  benefits_start_date: string;
  employment_end_date?: string | null;
}[];

export type ValidateUserDataError = {
  severity: string;
  fieldName: string;
  message: string;
  stackTrace: string;
  elementIndex?: number;
  code: string;
};

export type ValidateUserDataResponseItemError = {
  fieldName: string;
  errorCodes: string[];
};

export type ValidateUserDataResponseItem = {
  id: string;
  isValid: boolean;
  errors: ValidateUserDataResponseItemError[];
};

export type ValidateUserDataResponse = {
  isValid: boolean;
  responseItems: ValidateUserDataResponseItem[];
};

export type ImportUserDataPayload = {
  first_name: string;
  last_name: string;
  email_address: string;
  employee_number?: string;
  working_hours_percentage: number;
  department?: string;
  floor?: string;
  region?: string;
  cost_center_number?: number;
  lunch_benefit_monthly_days?: number;
  benefits_start_date: string;
  employment_end_date?: string;
  benefit_group: string;
  personal_id: string;
  employment_type: string;
}[];

export type ImportUserDataResponse = {
  id: number;
};

type ImportStatus =
  | 'Created'
  | 'Processed'
  | 'ProcessedWithErrors'
  | 'Failed'
  | 'Canceled';

export type ImportStatusResponse = {
  isAnyImportInProgress: boolean;
  status: ImportStatus;
  beneficiariesToCreate: number;
  beneficiariesToUpdate: number;
};
